import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BrandsHomeComponent from "./components/BrandsHome.component.vue";
import CarouselHomeComponent from "./components/CarouselHome.component.vue";
import CarouselProductsComponent from "./components/CarouselProducts.component.vue";
import CategoriesHomeComponent from "./components/CategoriesHome.component.vue";
import StrongsHomeComponent from "./components/StrongsHome.component.vue";
import VerificationHomeComponent from "./components/VerificationHome.component.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CarouselHomeComponent),
    _createVNode(CategoriesHomeComponent),
    _createVNode(CarouselProductsComponent),
    _createVNode(BrandsHomeComponent),
    _createVNode(StrongsHomeComponent),
    _createVNode(VerificationHomeComponent)
  ], 64))
}
}

})